// PKT-0873 · the one navigation the Messages rail's "Call" performs.
//
// Kept in its own module so tests can assert the dialer was launched with the
// right number (jsdom cannot navigate to tel:). Same number normalisation as
// Leads (ClientList `case "call"`) and the rail's own phone icon.

export function telHref(phone: string): string {
  return `tel:${phone.replace(/[^\d+]/g, "")}`;
}

export function openDialer(phone: string): void {
  window.location.href = telHref(phone);
}

/** The user-agent test Leads uses to pick the mobile handoff (ClientList). */
export function isMobileUserAgent(): boolean {
  if (typeof navigator === "undefined") return false;
  return /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );
}
